export function userAgentIsGoogleBot(): boolean {
    return /googlebot|google-inspectionTool/i.test(navigator.userAgent);
}
